import React, { useMemo, useState } from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faCheck, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../../components/ConfirmButton/ConfirmButton';

const SetView = ({ set, setInputs, setSetInputs, stages, eventSchedules, getArtists }) => {
    const [showControls, setShowControls] = useState(false);

    const filteredStages = useMemo(() => (
        (stages || []).filter(stage => stage.stageEventGUID === set.eventGUID)
    ), [stages, set.eventGUID]);

    const filteredEventSchedules = useMemo(() => (
        (eventSchedules || [])
            .filter(eventSchedule => eventSchedule.eventScheduleEventGUID === set.eventGUID)
            .sort((a, b) => {
                const orderDiff = (a.eventScheduleOrder || 0) - (b.eventScheduleOrder || 0);
                if (orderDiff !== 0) return orderDiff;
                return (a.eventScheduleStartDateTime || '').localeCompare(b.eventScheduleStartDateTime || '');
            })
    ), [eventSchedules, set.eventGUID]);

    const handleInputChange = (setGUID, field, value) => {
        setSetInputs(prev => ({
            ...prev,
            [setGUID]: {
                ...prev[setGUID],
                [field]: value
            }
        }));
    };

    const updateSet = (setGUID) => {
        const { setEventScheduleGUID, setStageGUID, setStartDateTime, setEndDateTime, setB2BOrder } = setInputs[setGUID] || {};
        fetch(`/api/set/${setGUID}`, {
            method: 'PUT',
            body: JSON.stringify({
                setEventScheduleGUID,
                setStageGUID,
                setStartDateTime,
                setEndDateTime,
                setB2BOrder
            }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    // refreshSetInputsFromSets();
                    getArtists();
                    return null;
                } else {
                    return null;
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setShowControls(false);
            });
    };

    const removeSet = (setGUID) => {
        fetch(`/api/set/${setGUID}`, {
            method: 'DELETE',
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    // refreshSetInputsFromSets();
                    getArtists();
                    return null;
                } else {
                    return null;
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setShowControls(false);
            });
    };

    const toTime12h = (dtString) => {
        if (!dtString) return null;
        const d = new Date(dtString);
        const hours = d.getHours();
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const hour12 = hours % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    const displayList = [set.stageName, set.eventScheduleTitle, [toTime12h(set.setStartDateTime),toTime12h(set.setEndDateTime)].filter(item => item).join(' - ')];
    
    return (
        <Row className='mb-1 align-items-center text-secondary'>
            <Col xs={8} className='pb-2 ps-4'>{displayList.filter(item => item).join(' • ')}</Col>
            <Col xs={4} className='pb-2 d-flex justify-content-end align-items-start'>
                {!showControls && <Button
                    className='me-3 text-white'
                    color="black"
                    onClick={() => setShowControls(true)}
                ><FontAwesomeIcon icon={faEdit} /></Button>}
                {showControls && <Button
                    className='me-3 text-white'
                    color="success"
                    onClick={() => updateSet(set.setGUID)}
                ><FontAwesomeIcon icon={faCheck} /></Button>}
                {showControls && <Button
                    className='me-3 text-white'
                    color="secondary"
                    onClick={() => setShowControls(false)}
                ><FontAwesomeIcon icon={faTimes} /></Button>}
                {showControls && <ConfirmButton
                    color="danger"
                    title="Remove Set"
                    onClick={() => removeSet(set.setGUID)}
                ><FontAwesomeIcon icon={faTrashAlt} /></ConfirmButton>}

            </Col>
            {showControls && <>
                <Col className='pb-2 px-1'>
                    <Input
                        type="select"
                        value={setInputs[set.setGUID]?.setEventScheduleGUID || ''}
                        onChange={(e) => handleInputChange(set.setGUID, 'setEventScheduleGUID', e.target.value)}
                    >
                        <option value="">SELECT DAY</option>
                        {filteredEventSchedules.map(eventSchedule => (
                            <option key={eventSchedule.eventScheduleGUID} value={eventSchedule.eventScheduleGUID}>
                                {eventSchedule.eventScheduleTitle}
                            </option>
                        ))}
                    </Input>
                </Col>
                <Col className='pb-2 px-1'>
                    <Input
                        type="select"
                        value={setInputs[set.setGUID]?.setStageGUID || ''}
                        onChange={(e) => handleInputChange(set.setGUID, 'setStageGUID', e.target.value)}
                    >
                        <option value="">SELECT STAGE</option>
                        {filteredStages.map(stage => (
                            <option key={stage.stageGUID} value={stage.stageGUID}>{stage.stageName}</option>
                        ))}
                    </Input>
                </Col>
                <Col className='pb-2 px-1'>
                    <Input
                        type="time"
                        value={setInputs[set.setGUID]?.setStartDateTime || ''}
                        onChange={(e) => handleInputChange(set.setGUID, 'setStartDateTime', e.target.value)}
                    />
                </Col>
                <Col className='pb-2 px-1'>
                    <Input
                        type="time"
                        value={setInputs[set.setGUID]?.setEndDateTime || ''}
                        onChange={(e) => handleInputChange(set.setGUID, 'setEndDateTime', e.target.value)}
                    />

                </Col>
                <Col className='pb-2 px-1'>
                    <Input
                        style={{ width: '60px' }}
                        type="number"
                        value={setInputs[set.setGUID]?.setB2BOrder || ''}
                        onChange={(e) => handleInputChange(set.setGUID, 'setB2BOrder', e.target.value)}
                    />
                </Col>
            </>}

        </Row>
    );
}

export default SetView;
